// hooks/redux/syncAcrossTabsMiddleware.js
import { RESET_STORE } from "./actions/resetAction";

export const syncAcrossTabsMiddleware = (allowedActionPrefixes = []) => {
  const channel = new BroadcastChannel("redux_sync_channel");

  return (store) => (next) => (action) => {
    const result = next(action);

    // 🔥 sync reset global
    if (action.type === RESET_STORE) {
      channel.postMessage({ type: "RESET_STORE" });
      return result;
    }

    // sync partiel
    // Diffuse uniquement certaines actions
    if (
      allowedActionPrefixes.some((prefix) => action.type.startsWith(prefix))
    ) {
      const stateToSync = store.getState();

      channel.postMessage({
        type: "SYNC_STATE",
        payload: stateToSync,
      });
    }

    return result;
  };
};

// Écoute inter-onglets
export const setupBroadcastListener = (store) => {
  const channel = new BroadcastChannel("redux_sync_channel");

  channel.onmessage = (event) => {
    const { type, payload } = event.data || {};

    if (type === "RESET_STORE") {
      store.dispatch({ type: RESET_STORE });
      return;
    }

    if (type === "SYNC_STATE" && payload) {
      Object.entries(payload).forEach(([sliceName, sliceValue]) => {
        store.dispatch({
          type: `SYNC/${sliceName}`,
          payload: sliceValue,
        });
      });
    }
  };
};
